var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1 ma-0",attrs:{"full-width":"","headers":_vm.headers,"loading":_vm.loading,"items-per-page":25,"items":_vm.items,"search":_vm.search,"readonly":true,"footer-props":{
    'items-per-page-options': [10,25,50]
  },"sort-by":['freq', 'a1'],"sort-desc":[true]},scopedSlots:_vm._u([{key:"item.freq",fn:function(ref){
  var item = ref.item;
return [_c('v-layout',{attrs:{"justify-center":""}},[_c('v-chip',{attrs:{"color":_vm.frequencyColor(item.freq),"text-color":"white","ml-3":""}},[_vm._v(_vm._s(item.freq))])],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }